import { SalesforceActionFacadeBase } from './salesforce.actionfacade-base';

export class SalesforceClassicActionFacade extends SalesforceActionFacadeBase {}
